module.exports = __webpack_public_path__ + "static/media/icon-postweb.3e6d35c8.svg";